module.exports = __webpack_public_path__ + "static/media/appstore-6g.00197133.png";